import { useRecoilState } from "recoil";
import {useEffect, useRef} from "react";
import {FeedbackForm} from "./FeedbackForm";
import {api} from "../../config/ApiConfig";
import {feedbackModalState} from "../../recoil/feedbackModalState";
import {useModal, useToast} from "../../../hooks";




/*
 * @BASE
 * Base API info for Feedback submission
 */
export const BASE = {
    api: `${process.env.REACT_APP_API_PTLE}/api/v1/ptle/extptl/revw/cstmr`,
};

export const APIS = {
    saveFeedback: (usrFdbckPrcssId: string, data: any) => {
        return api.post(`${BASE.api}/${usrFdbckPrcssId}`, data);
    },
};

/*
 * GlobalFeedbackModal
 * Opens automatically whenever triggerCount increments
 */
export function GlobalFeedbackModal() {
    const [state, setState] = useRecoilState(feedbackModalState);

    const ratingRef = useRef(state.rating);
    const commentRef = useRef(state.comment);
    const tagsRef = useRef(state.tags);

    const modal = useModal();
    const toast = useToast();

    const submitFeedback = async () => {
        if (!state.processId) {
            toast.showToast({ type: "error", content: "Missing process ID" });
            return;
        }

        try {
            await APIS.saveFeedback(state.processId, {
                rating: ratingRef.current,
                revwCmnt: commentRef.current,
                tags: Array.isArray(tagsRef.current) ? tagsRef.current.join(",") : tagsRef.current,
                usrId: state.userId,
                trgt_reff: state.targetId,
            });

            toast.showToast({ type: "success", content: "Feedback successfully submitted!" });

            // Call the onSubmit callback with feedback data
            if (state.onSubmit) {
                state.onSubmit({
                    rating: ratingRef.current,
                    comment: commentRef.current,
                    tags: tagsRef.current
                });
            }

            // Close modal and clean up
            setState(prev => ({
                ...prev,
                visible: false,
                onSubmit: undefined,
                onCancel: undefined
            }));

        } catch (err) {
            console.error("Feedback submit error:", err);
            toast.showToast({ type: "error", content: "Failed to submit feedback." });
        }
    };

    const handleCancel = () => {
        // Call the onCancel callback if it exists
        state.onCancel?.();

        // Close modal and clean up
        setState(prev => ({
            ...prev,
            visible: false,
            onSubmit: undefined,
            onCancel: undefined
        }));
    };

    useEffect(() => {
        if (!state.userId || !state.processId) return;

        modal.openModal({
            size: "xs",
            title: "We value your feedback",
            content: (
                <FeedbackForm
                    onChange={(rating, comment, tags) => {
                        ratingRef.current = rating;
                        commentRef.current = comment;
                        tagsRef.current = tags;
                    }}
                />
            ),
            confirmText: "Submit Feedback",
            cancelText: "Cancel",
            onConfirm: submitFeedback,
            onCancel: handleCancel,
        });
    }, [state.triggerCount]);

    return null;
}